import FavsWidget from '../FilmFavs/FavsWidget';
import { musicFavsConfig } from './config';

const MusicFavs = () => <FavsWidget config={musicFavsConfig} />;

export default MusicFavs;
